module.exports = __webpack_public_path__ + "static/media/agent-processing.ba29f9c9.svg";